import { unique } from 'radash';
import useSWR, { SWRResponse } from 'swr';

import { Component } from 'models';

import { ComponentService } from 'services/ComponentService';

const useProductsByIds = (
    ids: string[],
): SWRResponse & {
    components: Component[];
} => {
    const swr = useSWR(ids.length ? `/components/${ids.join(',')}` : null, () => ComponentService.getMultiple(ids), {
        revalidateOnFocus: false,
        keepPreviousData: true,
    });

    const componentsById = new Map<string, Component>(
        (swr.data?.docs ?? []).map((component: Component) => [component.id, component]),
    );

    return {
        ...swr,
        components: unique(ids)
            .map((id) => componentsById.get(id))
            .filter((component): component is Component => Boolean(component)),
    };
};

export { useProductsByIds };
